import { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';

function InviteNewCollectorModal({ isOpen, setIsOpen, type, submitEmail }) {

  const [email, setEmail] = useState('');

  const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    submitEmail(email, type);
    setIsOpen(false);
    return false;
  }

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        onClose={() => setIsOpen(false)}
        className="relative z-50">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
        </Transition.Child>
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95">
            <Dialog.Panel className=" max-w-xs  md:max-w-lg transform overflow-hiddn transition-all">
              <div className="relative bg-white rounded-none p-4 md:p-6 text-left shadow-xl">
                <button
                  type="button"
                  className="absolute -top-2 -right-4 text-ato-red bg-white border-2 border-gray-200 hover:bg-gray-200 rounded-full text-sm p-1.5 ml-auto inline-flex items-center focus:outline-none"
                  data-modal-toggle="authentication-modal"
                  onClick={() => setIsOpen(false)}>
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"></path>
                  </svg>
                </button>
                <div className=" mt-7 space-y-3 py-6 px-6 lg:px-8">
                  <div className="py-1 flex justify-center text-ato-red">
                    <svg
                      viewBox="0 0 98 98"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-16 h-16">
                      <path d="M88.2 0H9.8C4.41 0 0 4.41 0 9.8V98L19.6 78.4H88.2C93.59 78.4 98 73.99 98 68.6V9.8C98 4.41 93.59 0 88.2 0Z" />
                      <path
                        d="M28 37.5C28 25.623 37.3992 16 49 16C60.6008 16 70 25.623 70 37.5C70 49.377 60.6008 59 49 59C37.3992 59 28 49.377 28 37.5ZM40.1597 40.0054L46.2903 33.4601L46.2903 49.2903C46.2903 50.4433 47.1964 51.371 48.3226 51.371L49.6774 51.371C50.8036 51.371 51.7097 50.4433 51.7097 49.2903L51.7097 33.4601L57.8403 40.0054C58.6278 40.8464 59.9403 40.8637 60.7448 40.0401L61.6677 39.0865C62.4637 38.2716 62.4637 36.9538 61.6677 36.1476L50.4395 24.6433C49.6435 23.8284 48.3565 23.8284 47.569 24.6433L36.3238 36.1476C35.5278 36.9625 35.5278 38.2802 36.3238 39.0865L37.2468 40.0401C38.0597 40.8637 39.3722 40.8464 40.1597 40.0054Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className=" leading-3">
                    <h3 className=" items-center text-2xl tracking-wider md:text-3xl text-center font-millerBanner text-ato-red">
                      Send Invite To New {type==='collector'?"Collector":(type==='artist'?"Artist":"Authenticator")}
                    </h3>
                    <h4 className=" w-4/5 md:w-2/3 text-sm md:text-base text-center mx-auto font-universLight font-medium md:font-thin text-ato-form-text">
                      Send invite to the new owner of the artwork via email
                    </h4>
                  </div>
                  <form className="space-y-4 flex flex-col" action="#" onSubmit={onSubmit}>
                    <div>
                      <input
                        type="email"
                        name="email"
                        className=" w-full md:w-[70%] bg-white border text-ato-form-text text-md block p-2.5 mx-auto focus:outline-none md:mb-2"
                        placeholder="Email id"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <button
                      type="submit"
                      className=" w-full md:w-[45%] text-ato-upload-text bg-ato-upload-button font-medium font-millerBanner px-5 py-2.5 text-center mx-auto"
                    >
                      Send Invite
                    </button>
                  </form>
                </div>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}

export default InviteNewCollectorModal;
